import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { CookieConsentBanner } from './CookieConsentBanner.tsx';

const LazyForPaintCookieConsentBanner = lazyForPaint<typeof CookieConsentBanner>(
	() =>
		// chunk name is async-cc-banner to avoid scripts with cookie/banner keywords getting blocked
		import(/* webpackChunkName: "async-cc-banner" */ './CookieConsentBanner.tsx').then(
			({ CookieConsentBanner }) => CookieConsentBanner,
		),
	{
		ssr: true,
		entryFsSsrLiftImportToModule: true,
		// eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
		includeInShellOnlySsrBundle: true,
	},
);

export const CookieConsentBannerAsync = (): React.JSX.Element => (
	<Box xcss={boxStyles}>
		<JSErrorBoundary
			id="async-cookie-consent-banner"
			packageName="jiraCookieConsentBanner"
			teamName="Magma"
		>
			<Placeholder name="async-cookie-consent-banner" fallback={null}>
				<LazyForPaintCookieConsentBanner />
			</Placeholder>
		</JSErrorBoundary>
	</Box>
);

const boxStyles = xcss({
	backgroundColor: 'elevation.surface.sunken',
	height: '100%',
});
